import { Link } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

const archiveLinks = [
  { label: "言语围攻", to: "/stories?category=言语围攻" },
  { label: "人肉搜索", to: "/stories?category=人肉搜索" },
  { label: "恶意剪辑", to: "/stories?category=恶意剪辑" },
  { label: "造谣诽谤", to: "/stories?category=造谣诽谤" },
];

const resourceLinks = [
  { label: "伤害与恢复", to: "/knowledge" },
  { label: "常见问题", to: "/knowledge#faq" },
  { label: "关于我们", to: "/about" },
  { label: "求助与联系", to: "/about#help" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 font-heading text-lg font-bold">
                回
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/80 max-w-md">
              {site.intro}
            </p>
            <p className="mt-5 text-sm text-background-200/70">
              来信：
              <a href={`mailto:${site.email}`} className="text-accent-400 hover:text-accent-300 transition-colors">
                {site.email}
              </a>
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-semibold text-background-50 tracking-wide">导航</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-semibold text-background-50 tracking-wide">档案分类</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {archiveLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold text-background-50 tracking-wide">资源</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-background-300/60">
              紧急情况请优先联系当地公安机关或专业心理援助热线。本平台内容不构成医疗或法律建议。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © {site.foundedYear}–2026 {site.fullName}　保留所有权利
          </p>
          <p className="text-xs text-background-300/70">内容均为化名整理，请勿对号入座或二次传播</p>
        </div>
      </div>
    </footer>
  );
}